import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import dayjs from 'dayjs';

import Chip from '../Chip/Chip';

import { locations } from '../../util/locations';

const LDN = 'London';
const SF = 'San Francisco';
const chosenLocationQ = 'Which event is this chosen for?';
const dateFormat = 'ddd D MMM';

const Schedule = ({ location }) => {
  const scheduleQuery = useStaticQuery(graphql`
    query {
      allBuilderModels {
        preliminarySchedule (
          options: {
            cachebust: true
          }
        ) {
          id
          data {
            start
            end
            location
            title
            description
          }
        }
      }
      allPretalxSubmission(filter: {state: {eq: "confirmed"}}) {
        edges {
          node {
            slot {
              start
              end
              room {
                en
              }
            }
            id
            tags
            title
            path
            abstract {
              childMarkdownRemark {
                excerpt(pruneLength: 150)
              }
            }
            submission_type {
              en
            }
            speakers {
              pretalxSpeaker {
                path
                name
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 80, height: 80)
                  }
                }
              }
            }
            answers {
              answer
              question {
                question {
                  en
                }
              }
            }
          }
        }
      }
    }
  `);

  const [schedule, setSchedule] = useState();
  const [selectedDay, setSelectedDay] = useState();

  useEffect(() => {
    if (!scheduleQuery) {
      return;
    }

    const builderList = scheduleQuery?.allBuilderModels?.preliminarySchedule;
    const pretalxList = scheduleQuery?.allPretalxSubmission?.edges;

    if (!builderList && !pretalxList) {
      return;
    }
    const sanitisedBuilderList = builderList
      .filter((item) => item.data.start && item.data.end)
      .map((item) => {
        return { id: item.id, ...item.data, start: dayjs(item.data.start), end: dayjs(item.data.end) };
      });

    const sanitisedPretalxList = pretalxList
      .filter(({ node }) => node.slot?.start && node.slot?.end)
      .map(({ node }) => {
        return {
          ...node,
          start: dayjs(node.slot.start),
          end: dayjs(node.slot.end),
          isRemote: node.tags.includes('Remote'),
        };
      });

    sanitisedPretalxList.forEach((t) => {
      t.answers.forEach(({ question, answer }) => {
        if (question.question.en === chosenLocationQ && locations.includes(answer)) {
          t.location = answer;
          if (answer === LDN) {
            t.start = t.start.subtract(1, 'hour');
            t.end = t.end.subtract(1, 'hour');
          }
          if (answer === SF) {
            t.start = t.start.subtract(9, 'hour');
            t.end = t.end.subtract(9, 'hour');
          }
        }
      });
    });

    const newSchedule = new Map();
    [LDN, SF].forEach((loc) => {
      newSchedule.set(
        loc,
        new Map()
      );
    });

    const ldnEvents = [...sanitisedBuilderList, ...sanitisedPretalxList]
      .filter((item) => item.location === LDN)
      .sort((a, b) => a.start - b.start);

    const sfEvents = [...sanitisedBuilderList, ...sanitisedPretalxList]
      .filter((item) => item.location === SF)
      .sort((a, b) => a.start - b.start);

    ldnEvents.forEach((ev) => {
      const date = ev.start.format(dateFormat);
      const ldnSchedule = newSchedule.get(LDN);
      if (!ldnSchedule.has(date)) {
        ldnSchedule.set(date, []);
      }
      ldnSchedule.get(date).push(ev);
    });

    sfEvents.forEach((ev) => {
      const date = ev.start.format(dateFormat);
      const sfSchedule = newSchedule.get(SF);
      if (!sfSchedule.has(date)) {
        sfSchedule.set(date, []);
      }
      sfSchedule.get(date).push(ev);
    });

    setSchedule(newSchedule);
  }, [scheduleQuery]);

  useEffect(() => {
    if (location && schedule && schedule.has(location)) {
      const locationDates = Array.from(schedule.get(location).keys());
      const today = dayjs().format(dateFormat);
      if (locationDates.find((date) => date === today)) {
        setSelectedDay(today);
      } else {
        setSelectedDay(locationDates[0]);
      }
    }
  }, [schedule, location]);

  function generateSchedule(date) {
    if (!schedule.has(location)) {
      return <></>;
    }
    const localSchedule = schedule.get(location);
    if (!localSchedule.has(date)) {
      return <></>;
    }
    const dateSchedule = localSchedule.get(date);
    return (
      <>
        {dateSchedule.map((talk, idx) => (
          <div className={`events-items ${idx % 2 === 0 ? '' : 'highlight'}`} key={talk.id}>
            <div className='row'>
              <div className='col-lg-4'>
                <div className='event-author'>
                  <div className='speak-date'>
                    <i className='flaticon-clock-1'></i>
                    <div className='date'>{startEndString(talk.start, talk.end, location)}</div>
                  </div>
                </div>
              </div>
              <div className='col-lg-8'>
                <div
                  className='event-shedule-info'
                >
                  <div className='rs-topic-content'>
                    {/* {room !== 'break' && (
                      <p className='subtitle'>{room}</p>
                    )} */}
                    {talk.path && talk.submission_type.en === 'Talk' ? (
                      <Link to={talk.path}>
                        <h3 className='event-title'>{talk.title}</h3>
                      </Link>
                    ) : (
                      <h3 className='event-title'>{talk.title}</h3>
                    )}
                    {talk.abstract?.childMarkdownRemark && (
                      <p>{talk.abstract.childMarkdownRemark.excerpt}</p>
                    )}
                    {talk?.description !== '<p><br></p>' && (
                      <p dangerouslySetInnerHTML={{
                        __html: talk?.description
                      }} />
                    )}
                    {talk.isRemote && <Chip type='remote' />}
                    {talk.isWorkshop && <Chip type='workshop' />}
                  </div>
                  <div className='all-seack'>
                    {talk.speakers?.map((speaker) => {
                      const { name, path, localFile } = speaker.pretalxSpeaker;
                      return (
                        <div
                          className='speak-image'
                          key={`${talk.id}-${name}`}
                        >
                          <Link to={path}>
                            <GatsbyImage image={getImage(localFile)} alt={name} />
                          </Link>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  }

  if (!schedule) {
    return <></>;
  }

  return (
    <div
      id='rs-events-schedule'
      className='rs-events-schedule rs-events-schedule3 event-home6-style bg25 pb-120 md-pt-65 md-pb-80'
    >
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='events-schedule-tabs'>
              <ul className='nav eventday-list'>
                {Array.from(schedule.get(location).keys()).map((date, idx) => (
                  <li className='nav-item' key={date}>
                    <a
                      className={`nav-link ${selectedDay === date ? 'active' : ''}`}
                      onClick={() => setSelectedDay(date)}
                    >
                      Day {idx+1}<span>{date}</span>
                    </a>
                  </li>
                ))}
              </ul>
              <div className='events-schedule-contents tab-content schedule-one'>
                <div className='tab-pane events-shedule-des active show'>
                  {generateSchedule(selectedDay)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const startEndString = (start, end, loc) => {
  if (!start || !end) {
    return '-';
  }
  let locale = 'en-GB';
  let timeZone = 'Europe/London';
  if (loc === SF) {
    locale = 'en-US';
  }
  return `${start.toDate().toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', timeZone })} - ${end.toDate().toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', timeZone })}`;
}

export default Schedule;
